import FormSection from '@/components/Forms/FormSection';
import { CommonFormSection } from '@/components/ProductionValueCheck/Form';
import { currencyFormatter } from '@/helpers/currencyFormatter';
import { useGetAccountQuery } from '@/services/accounts';
import { useGetQuotesQuery } from '@/services/quotes';
import { ReviewPackageActions } from '@/types/ReviewPackage';
import { Box } from '@palmetto/palmetto-components';
import { useParams } from 'react-router-dom';

import { WaterHeaterInstallPackageFileCategory, InstallDocumentTypes, QuoteStatus } from 'types';

import { DocumentList } from '../Documents/DocumentList';

type InstallContractProps = {
  allowArchive?: boolean;
  showCheckboxes: boolean;
  checkboxCategories: WaterHeaterInstallPackageFileCategory[];
  isPackageEditable?: boolean;
};

export const InstallContract = ({
  allowArchive,
  showCheckboxes,
  checkboxCategories,
  isPackageEditable = true,
}: InstallContractProps) => {
  const { id = '' } = useParams<{ id: string; action: ReviewPackageActions }>();
  const { data: account } = useGetAccountQuery(id);
  const { data: quotes } = useGetQuotesQuery(
    { id, programType: account?.programType },
    { skip: !account?.programType },
  );
  const activeQuote = quotes?.find((quote) => quote.status === QuoteStatus.active);
  const quoteTotalSystemCost = activeQuote?.totalSystemCost ?? 0;
  return (
    <FormSection
      title="Install Contract"
      description="Upload a copy of your contract with the homeowner. This is most often an Install Contract, but can also be a Home Improvement Contract, a Work Order, signed Invoice, or similar document with installed equipment details visible."
    >
      <DocumentList
        documentTypeFilter={[InstallDocumentTypes.installContract]}
        title="Install Contract"
        showTypeLabelOnItems={false}
        baseCategory={'Install Contract'}
        allowArchive={allowArchive}
        showCheckboxes={showCheckboxes}
        checkboxCategories={checkboxCategories}
        isPackageEditable={isPackageEditable}
      />
      <CommonFormSection title="Quote Total Financed Amount">
        <Box fontWeight={'medium'} fontSize={'lg'}>
          {currencyFormatter.format(quoteTotalSystemCost)}
        </Box>
      </CommonFormSection>
    </FormSection>
  );
};
